import { MediaTag } from '@src/api/types/mediaTag';
import Input from '@src/ui/elements/form/Input';
import Select from '@src/ui/elements/form/Select';
import Tag from '@src/ui/elements/form/Tag';

interface TagFieldProps {
  tags: number[];
  newTagName: string;
  setNewTagName: (newTagName: string) => void;
  onNewTag: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onAddTag: (tagId: string) => void;
  onRemoveTag: (index: number) => void;
  error?: string | null;
  availableTags: MediaTag[];
}

const TagField: React.FC<TagFieldProps> = ({
  tags,
  newTagName,
  setNewTagName,
  onNewTag,
  onAddTag,
  onRemoveTag,
  error,
  availableTags,
}) => (
  <div className='flex flex-col gap-[6px]'>
    <div className='flex items-end gap-[6px]'>
      <p className='text-sm'>タグ</p>
      <span className='text-[10px]'>※タグの登録は10個までとなります</span>
    </div>

    {tags.length < 10 && (
      <Input
        value={newTagName}
        placeholder='新規タグを追加'
        onChange={(e) => setNewTagName(e.target.value)}
        onKeyDown={onNewTag}
      />
    )}

    {tags.length > 0 && (
      <div className='rounded border border-solid border-gray-250 bg-white p-4'>
        <div className='flex flex-wrap gap-[10px]'>
          {tags.map((tagId, index) => {
            const tag = availableTags.find((t) => t.id === tagId);
            return tag ? (
              <Tag
                key={tag.id}
                index={index}
                text={tag.name}
                onClick={() => onRemoveTag(index)}
              />
            ) : null;
          })}
        </div>
      </div>
    )}

    <div className='flex flex-col gap-2 pt-1'>
      <div className='flex justify-between text-xs'>
        <div>{tags.length < 10 && <p>作成済みのタグを追加</p>}</div>
        <p data-testid='tag-limit'>{tags.length}/10</p>
      </div>
      {tags.length < 10 && (
        <Select
          items={availableTags.map((tag) => ({
            id: tag.id.toString(),
            name: tag.name,
          }))}
          onSelect={onAddTag}
        />
      )}
    </div>

    {error && <p className='text-xs text-red-500'>{error}</p>}
  </div>
);

export default TagField;
